import { useState } from "react";
import { useTranslate } from "@refinedev/core";

import { usePaginatedTable, useQueryParams } from "@shared/hooks";
import { Partner } from "@modules/partners/types";
import {
  useApprovePartnerMutation,
  useRejectPartnerMutation,
} from "@modules/partners/services/mutations";
import { usePartnerSummaryQuery } from "@modules/partners/services/queries";

export function usePartnersTab() {
  const translate = useTranslate();
  const { getQueryParams } = useQueryParams();
  const [rejectTarget, setRejectTarget] = useState<Partner | null>(null);

  const { tab, ...filters } = getQueryParams();

  const { rows, loading, refetch, ...tableProps } = usePaginatedTable<Partner>({
    resource: "v1/partner_admin",
    filters,
    sorters: { ordering: "-id" },
  });

  const { data: summary } = usePartnerSummaryQuery();

  const approveMutation = useApprovePartnerMutation();
  const rejectMutation = useRejectPartnerMutation();

  const handleApprove = async (id: number) => {
    await approveMutation.mutateAsync(id);
    refetch();
  };

  const handleReject = async (reason: string) => {
    if (!rejectTarget) return;
    await rejectMutation.mutateAsync({
      id: rejectTarget.id,
      rejection_reason: reason,
    });
    setRejectTarget(null);
    refetch();
  };

  return {
    rows,
    loading,
    tableProps,
    summary,
    rejectTarget,
    isRejecting: rejectMutation.isPending,
    setRejectTarget,
    handleApprove,
    handleReject,
    refetch,
    translate,
  };
}
